import React from 'react';
import EventEmitter from './publisher';

export default class Loader extends React.Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		if(!this.props.loading) return null
		return (
			<div className="loader">
				<div className="loaderText">
					{this.props.loaderText}
				</div>
			</div>
		)
	}
}

Loader.defaultProps ={
	loading: false,
	loaderText: ''
}


/** WEBPACK FOOTER **
 ** ./app/reusable/loader.js
 **/